export default "__VITE_ASSET__B7EI_w8___"